/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new role.
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerCreate: (createRoleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createRoleDto' is not null or undefined
            assertParamExists('rolesV2ControllerCreate', 'createRoleDto', createRoleDto);
            const localVarPath = `/v2/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get All Roles
         * @param {UserTypeEnum} [roleType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerFindAll: (roleType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (roleType !== undefined) {
                localVarQueryParameter['roleType'] = roleType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Role by Key
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerFindOne: (key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('rolesV2ControllerFindOne', 'key', key);
            const localVarPath = `/v2/role/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete Role by Key
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerRemove: (key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('rolesV2ControllerRemove', 'key', key);
            const localVarPath = `/v2/role/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing role.
         * @param {string} key
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerUpdate: (key, updateRoleDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('rolesV2ControllerUpdate', 'key', key);
            // verify required parameter 'updateRoleDto' is not null or undefined
            assertParamExists('rolesV2ControllerUpdate', 'updateRoleDto', updateRoleDto);
            const localVarPath = `/v2/role/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function (configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new role.
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerCreate(createRoleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rolesV2ControllerCreate(createRoleDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get All Roles
         * @param {UserTypeEnum} [roleType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerFindAll(roleType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rolesV2ControllerFindAll(roleType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Role by Key
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerFindOne(key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rolesV2ControllerFindOne(key, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete Role by Key
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerRemove(key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rolesV2ControllerRemove(key, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing role.
         * @param {string} key
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerUpdate(key, updateRoleDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rolesV2ControllerUpdate(key, updateRoleDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RolesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new role.
         * @param {CreateRoleDto} createRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerCreate(createRoleDto, options) {
            return localVarFp
                .rolesV2ControllerCreate(createRoleDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get All Roles
         * @param {UserTypeEnum} [roleType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerFindAll(roleType, options) {
            return localVarFp
                .rolesV2ControllerFindAll(roleType, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Role by Key
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerFindOne(key, options) {
            return localVarFp
                .rolesV2ControllerFindOne(key, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Role by Key
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerRemove(key, options) {
            return localVarFp
                .rolesV2ControllerRemove(key, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing role.
         * @param {string} key
         * @param {UpdateRoleDto} updateRoleDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesV2ControllerUpdate(key, updateRoleDto, options) {
            return localVarFp
                .rolesV2ControllerUpdate(key, updateRoleDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     *
     * @summary Create a new role.
     * @param {CreateRoleDto} createRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesV2ControllerCreate(createRoleDto, options) {
        return RolesApiFp(this.configuration)
            .rolesV2ControllerCreate(createRoleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get All Roles
     * @param {UserTypeEnum} [roleType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesV2ControllerFindAll(roleType, options) {
        return RolesApiFp(this.configuration)
            .rolesV2ControllerFindAll(roleType, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Role by Key
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesV2ControllerFindOne(key, options) {
        return RolesApiFp(this.configuration)
            .rolesV2ControllerFindOne(key, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Role by Key
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesV2ControllerRemove(key, options) {
        return RolesApiFp(this.configuration)
            .rolesV2ControllerRemove(key, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing role.
     * @param {string} key
     * @param {UpdateRoleDto} updateRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    rolesV2ControllerUpdate(key, updateRoleDto, options) {
        return RolesApiFp(this.configuration)
            .rolesV2ControllerUpdate(key, updateRoleDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
